// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ijd2","name":"styles_name__x7PhJ","phone":"styles_phone__1a0ot"};